module.exports = __webpack_public_path__ + "img/garbage.833ab525.svg";